export const statusOptions = [
  { uuid: "inactive", name: "Неактивно" },
  { uuid: "preorder", name: "Предзаказ" },
  { uuid: "new", name: "Новинка" },
  { uuid: "available", name: "Доступно" },
];
